export default __webpack_public_path__ + "static/media/kwali_logo_anim.24fb5034.gif";